const storage = localStorage;

const keys = {
    announcement: 'Announcement',
};

const get = <T = unknown>(key: string) => (storage.getItem(key) ? (JSON.parse(storage.getItem(key)!) as T) : null);
const set = <T = unknown>(key: string, value: T) => storage.setItem(key, JSON.stringify(value));

export const localStore = { get, set, keys };

export const getLocalStorageSafe = (key: string) => {
    let value: string | null = '';
    try {
        value = localStorage.getItem(key);
    } catch (_e) {
        console.error('localStorage.getItem is not available');
    }
    return value;
};

export const setLocalStorageSafe = (key: string, value: unknown) => {
    try {
        localStorage.setItem(key, String(value));
    } catch (_e) {
        console.error('localStorage.setItem is not available');
    }
};
